import { Button } from '@mantine/core';
import { FaTrash } from 'react-icons/fa';

interface DeleteRecordButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

export const DeleteRecordButton = ({ disabled = false, onClick }: DeleteRecordButtonProps) => {
  return (
    <Button
      variant="outline"
      color="red"
      leftSection={<FaTrash size={16} />}
      disabled={disabled}
      onClick={onClick}
    >
      Delete
    </Button>
  );
};